import * as type from '../actions/types';

const initialState = {
    data: [],
    loading: false,
    error: null,
}

export default function projectVideoData(state = initialState, action) {
    switch (action.type) {
        case type.GET_PROJECT_VIDEOS_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_PROJECT_VIDEOS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data,
            }
        case type.GET_PROJECT_VIDEOS_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}